import { Navigate } from "react-router-dom";
import { getUserRole } from "../security/roleManager";
import { ROLES } from "../security/roles";

export default function LiveProtectedRoute({
  children
}) {

  const token = localStorage.getItem(
    "FENTASAFE_TOKEN"
  );

  const role = getUserRole();

  if (!token) {
    return <Navigate to="/live" replace />;
  }

  const allowedRoles = [
    ROLES.CUSTOMER_USER,
    ROLES.CUSTOMER_ADMIN,
    ROLES.FENTASAFE_ADMIN,
  ];

  if (!allowedRoles.includes(role)) {
    return <Navigate to="/" replace />;
  }

  return children;
}